<template>
  <div class="horizontal-chart" ng-if="data.length > 0">
    <div class="chart-content">
      <div class="chart-content-element" v-for="(item, i) in data" :key="i">
          <div class="player-header">
            <span class="player-color" :style="{ 'background-color' : options.color }"></span>
            <span class="text-gray player-name">{{item.title}}</span>
          </div>
          <div class="chart-wrapper">
            <div class="chart" :style="{ width: calculateChartWidthPercentage(item) + '%'}">
              <TimelineZone
                v-if="item.zone1"
                :id="'chartZone1Timeline'"
                :value="item.zone1"
                :custom-classes="'zone-1'"
                :unit="dataUnit"
                :width-percentage="zonePercentage(item.zone1)" />

              <TimelineZone
                v-if="item.zone2"
                :id="'chartZone2Timeline'"
                :value="item.zone2"
                :custom-classes="'zone-2'"
                :width-percentage="zonePercentage(item.zone2)"
                :unit="dataUnit"  />

              <TimelineZone
                v-if="item.zone3"
                :id="'chartZone3Timeline'"
                :value="item.zone3"
                :custom-classes="'zone-3'"
                :width-percentage="zonePercentage(item.zone3)"
                :unit="dataUnit"  />

              <TimelineZone
                v-if="item.zone4"
                :id="'chartZone4Timeline'"
                :value="item.zone4"
                :custom-classes="'zone-4'"
                :width-percentage="zonePercentage(item.zone4)"
                :unit="dataUnit"  />      
            </div>
            <div class="total-chart-wrapper">
              <div class="total-chart" :style="{ width: calculateChartWidthPercentage(item) + '%'}"></div>
              <div class="total-chart background-area"></div>
              <div 
                class="total-chart-label"
                v-if="calculateChartWidthPercentage(item) > 0"
                :style="{ width: `calc(${totalChartTooltipWidth(item)}% + 60px)`}">
                <span class="chart-label-text label-text">
                  {{ totalValue }}{{dataUnit}}
                </span> 
              </div>
            </div>
          </div>
          <div class="background-table">
            <div 
              class="background-table-cell" 
              v-for="(tick, i) in ticks" 
              :key="i"
              v-if="ticks.length > (i + 1)"
              ></div>
          </div>
      </div>
    </div>
    <div class="footer-x-axis">
      <div 
        class="tick" 
        v-for="(tick, i) in ticks" :key="i"
        :style="{ width: `calc(${xAxisDistance(i)}% + 60px)`}">
        <span class="axis-label label-text">{{ tick }} {{ tickUnit }}</span>
      </div>
    </div>
    <div class="bottom-chart-label chart-axis-label">
        {{ chartAxisLabel }}
    </div>
  </div>
</template>

<script>
import TimelineZone from '@/components/common/chart/horizontal-timeline-chart/TimelineZone'

export default {
  name: 'HorizontalTimelineChart',
  props: [
    'data',
    'maxValue',
    'ticks',
    'tickUnit',
    'dataUnit',
    'percentage',
    'maxPercentageValue',
    'chartAxisLabel'
  ],
  data () {
    return {
      options: {
        color: '#fffff'
      }
    }
  },
  computed: {
    totalValue () {
      let totalVal = 0

      this.data.forEach(item => {
        if(item.zone1) {
          totalVal += item.zone1
        }

        if(item.zone2) {
          totalVal += item.zone2
        }

        if(item.zone3) {
          totalVal += item.zone3
        }

        if(item.zone4) {
          totalVal += item.zone4
        }
      });

      return totalVal
    }
  },
  methods: {
    calculateChartWidthPercentage (item) {
      const maxValue = this.percentage ? this.maxPercentageValue : this.maxValue

      return (this.totalValue / maxValue) * 100
    },
    zonePercentage (zone) {
      const maxValue = this.percentage ? this.maxPercentageValue : this.maxValue

      return (zone / maxValue) * 100
    },
    totalChartTooltipWidth (item) {
      return this.calculateChartWidthPercentage(item) * 2
    },
    xAxisDistance (i) {
      return (100 / (this.ticks.length - 1)) * (i * 2)
    }
  },
  components: {
    TimelineZone
  }
}
</script>

<style lang="scss" scoped>
    .horizontal-chart-wrapper {
        .chart-axis-label {
            text-align: center;
            color: $mid-gray;

            &.top-chart-label {
              margin: 30px 0 50px;
            }

            &.bottom-chart-label {
              margin: 30px 0 50px;
            }
        }
    }

    .horizontal-chart {
        margin-bottom: 50px;
        margin-top: 90px;
        margin-left: 160px;
        padding: 0 20px;

        .label-text {
            font-size: 12px;
            white-space: nowrap;
            color: $mid-gray;
            position: relative;
            z-index: 9;
            background-color: $wood-smoke;
        }
        
        .chart-axis-label {
            text-align: center;
            color: $mid-gray;
            font-size: 14px;  

            &.bottom-chart-label {              
                margin: 50px 0 0px -160px;
            }
        }

        .chart-content {
            border-bottom: 1px solid $white;
            padding-bottom: 1px;
        }

        .header-x-axis, .footer-x-axis {
            width: 100%;
            left: -30px;
            right: 30px;
            top: -28px;
            position: relative;

            .axis-label {
                position: relative;
                color: $white;

                &::after {
                    content: '';
                    display: inline-block;
                    width: 1px;
                    height: 10px;
                    left: 0;
                    right: 0;
                    margin: auto;
                    background-color: $white;
                    position: absolute;
                }
            }

            .tick {
                position: absolute;
                left: 0;
                text-align: center;
            }
        }

        .header-x-axis {
            .axis-label {
                &::after {
                    bottom: -12px;
                }
            }
        }

        .footer-x-axis {
            top: auto;
            bottom: -15px;

            .axis-label {
                &::after {
                  top: -21px;
                }
            }
        }

        .chart-content-element {
            position: relative;
            height: 74px;
            padding-top: 30px;

            .player-header {
                margin-bottom: 60px;
                z-index: 9;
                position: absolute;
                left: -180px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                max-width: 178px;

                .player-name {
                  color: $mid-gray;
                  font-weight: 1000;
                  text-transform: uppercase;
                  font-size: 14px;
                }
            }

            .player-color {
                display: inline-block;
                height: 10px;
                width: 10px;
                border-radius: 2px;
                margin-left: 10px;
                margin-right: 5px;
            }

            .background-table {
                display: table;
                table-layout: fixed;
                border-collapse: collapse;
                width: 100%;
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                margin: auto;
                height: 100%;

                .background-table-cell {
                    display: table-cell;
                    border: 1px solid $shark-gray;
                }
            }

            .chart-wrapper {
                display: inline-block;
                position: relative;
                z-index: 99;

                .parallel-chart-wrapper {
                    position: relative;
                }

                .parallel-chart {
                    height: 10px;
                    background-color: $tundora;
                    position: relative;
                    top: -1px;
                }

                .parallel-chart-label {
                    position: absolute;
                    top: 25px;
                    right: 30px;
                    left: -30px;
                    color: $tundora;
                    text-align: center;

                    .chart-label-text {
                        position: relative;
                        color: $white;

                        &::before {
                            content: '';
                            display: inline-block;
                            height: 27px;
                            width: 1px;
                            position: absolute;
                            top: -29px;
                            background-color: $tundora;
                            left: 0;
                            right: 0;
                            margin: auto;
                        }
                    }
                }

                .total-chart-wrapper {
                    &.bottom-chart {
                        .total-chart-label {
                            top: auto !important;
                            bottom: -21px !important;
                        }

                        .chart-label-text::before {
                            top: -21px !important;
                            height: 20px !important;
                        }
                    }
                }

                .total-chart-label {
                    position: absolute;
                    top: 21px;
                    right: 30px;
                    left: -30px;
                    color: $white;
                    text-align: center;
                    z-index: 99;

                    .chart-label-text {
                        position: relative;
                        color: $white;

                        &::before {
                            content: '';
                            display: inline-block;
                            height: 25px;
                            width: 1px;
                            position: absolute;
                            top: -27px;
                            background-color: $white;
                            left: 0;
                            right: 0;
                            margin: auto;
                        }
                    }
                }

                .total-chart {
                    height: 1px;
                    background-color: $white;
                    position: relative;

                    .total-chart-label {
                        position: absolute;
                        right: 0;
                        color: $white;
                    }

                    &.background-area {
                        background-color: $shark-gray;
                    }
                }

                .chart {
                    display: table;
                    table-layout: fixed;

                    .zone {
                        display: table-cell;
                        height: 10px;
                        position: relative;
                        font-size: 12px;
                        color: $wood-smoke;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        width: 0;

                        > span {
                            text-overflow: ellipsis;
                            display: inline-block;
                            white-space: nowrap;
                        }

                        .zone-label {
                            position: absolute;
                            left: 0;
                            right: 0;
                            margin: auto;
                            display: inline-block;
                            text-align: center;
                            top: -22px;

                            &::after {
                                content: '';
                                display: inline-block;
                                height: 5px;
                                width: 1px;
                                left: 0;
                                right: 0;
                                margin: auto;
                                position: absolute;
                                background-color: inherit;
                            }

                            .label-text {
                                white-space: nowrap;
                            }
                        }  

                        &-missing-data {
                            background-color: $wood-smoke;
                            border: 1px solid $waterloo;
                            color: $white;
                        }
    
                        &-1 {
                            background-color: $boston-blue;

                            .zone-label {
                                .label-text {
                                    color: $boston-blue !important;
                                }
                                
                                &::after {
                                    bottom: -2px;
                                    background-color: $boston-blue;
                                }
                            }
                        }
    
                        &-2 {
                            background-color: $wasabi-green;

                            .zone-label {
                                top: -37px;
                                
                                .label-text {
                                    color: $wasabi-green !important;
                                }

                                &::after {
                                    bottom: -17px;
                                    height: 21px;
                                    background-color: $wasabi-green;
                                }
                            }
                        }
    
                        &-3 {
                            background-color: $fuel-yellow;

                            .zone-label {
                                top: -50px;

                                .label-text {
                                    color: $fuel-yellow !important;
                                }

                                &::after {
                                    bottom: -30px;
                                    height: 33px;
                                    background-color: $fuel-yellow;
                                }
                            }
                        }
    
                        &-4 {
                            background-color: $flush-mahogany;

                            .zone-label {
                                top: -63px;

                                .label-text {
                                    color: $flush-mahogany !important;
                                }

                                &::after {
                                    bottom: -41px;
                                    height: 44px;
                                    background-color: $flush-mahogany;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>
